import type { PatientStrings } from '../index';

export const mr: PatientStrings = {
  titleOne: 'तुमचा नवीन क्राउन',
  titleMany: 'तुमचे नवीन क्राउन',
  tooth: 'दात',
  teeth: 'दात',
  both: 'दोन्ही',
  overview: 'संपूर्ण दृश्य',
  front: 'समोरून',
  leftSide: 'डावी बाजू',
  rightSide: 'उजवी बाजू',
  bitingSurface: 'चावण्याची बाजू',
  show: 'दाखवा',
  newCrown: 'नवीन क्राउन',
  newCrowns: 'नवीन क्राउन',
  yourTeeth: 'तुमचे दात आणि हिरड्या',
  upperTeeth: 'वरचे दात',
  lowerTeeth: 'खालचे दात',
  hint: 'फिरवण्यासाठी ओढा · झूमसाठी पिंच किंवा स्क्रोल करा',
  zoomIn: 'जवळ करा',
  zoomOut: 'दूर करा',
  turnSlowly: 'हळू फिरवा',
  stopTurning: 'फिरवणे थांबवा',
  backToStart: 'सुरुवातीला परत',
  fullScreen: 'पूर्ण स्क्रीन',
  exitFullScreen: 'पूर्ण स्क्रीनमधून बाहेर',
  fromDentist: 'तुमच्या दंतवैद्यांकडून',
  shadeNote: (shade) =>
    `रंग साधारण शेड ${shade} सारखा दाखवला आहे. खऱ्या क्राउनचा रंग लॅबमध्ये जुळवला जातो.`,
  before: 'आधी',
  after: 'नंतर',
  seeInRoom: 'तुमच्या खोलीत पाहा',
  arNotSupported: 'क्राउन तुमच्या खोलीत पाहण्यासाठी हे पेज फोनवर उघडा.',
  appointmentTitle: 'क्राउन बसवण्याची तुमची अपॉइंटमेंट',
  confirm: 'निश्चित करा',
  confirmed: 'निश्चित झाले — तेव्हा भेटू',
  anotherTime: 'दुसरी वेळ मागा',
  anotherTimeSent: 'तुम्हाला दुसरी वेळ हवी आहे हे आम्ही तुमच्या दंतवैद्यांना कळवले आहे.',
  language: 'भाषा',
  largerText: 'मोठी अक्षरे',
};
